import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginFlowPage } from './login-flow.page';

const routes: Routes = [
  {
    path: '',
    component: LoginFlowPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginFlowPageRoutingModule {}
